import { render, staticRenderFns } from "./LoyaltyCardTT.vue?vue&type=template&id=7c6b5cb8&scoped=true"
import script from "./LoyaltyCardTT.vue?vue&type=script&lang=js"
export * from "./LoyaltyCardTT.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyCardTT.vue?vue&type=style&index=0&id=7c6b5cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b5cb8",
  null
  
)

export default component.exports